<div class="layout has-sidebar fixed-sidebar fixed-header">
    <aside id="sidebar" class="sidebar break-point-lg has-bg-image">
        <app-admin-side-nav></app-admin-side-nav>
    </aside>
    <div id="overlay" class="overlay"></div>
    <div class="layout">
        <!-- Header -->
        <header class="header">
            <div class="w-100 d-flex justify-content-between">
                <div>
                    <a id="btn-toggle" href="javascript:void(0)" class="sidebar-toggler break-point-lg">
                        <i class="ri-menu-line ri-xl"></i>
                    </a>
                </div>
                <div class="d-flex align-items-center gap-3 header-icon">
                    <!-- <span class="material-symbols-outlined" style="cursor: pointer;">
                        notifications
                    </span> -->
                    <div class="notification-wrapper" (click)="showNotification()">
                        <span class="material-symbols-outlined" style="cursor: pointer;">
                            notifications
                        </span>
                        <span class="notification-count" id="notificationCount"
                            *ngIf="notificationCount > 0">{{notificationCount}}</span>
                    </div>

                    <div class="me-4">
                        <div ngbDropdown class="home-pagedropdown">
                            <div class="" type="button" id="dropdownBasic1" ngbDropdownToggle>
                                <span class="material-symbols-outlined">
                                    manage_accounts
                                </span>
                            </div>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button ngbDropdownItem [routerLink]="['admin-profile']">Profile</button>
                                <!-- <button ngbDropdownItem [routerLink]="['/changePassword']">Change Password</button> -->
                                <button ngbDropdownItem (click)="logout()">Log Out</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="content">
            <router-outlet></router-outlet>
        </main>
        <div class="overlay"></div>
        <footer class="footer">SENEM RFP {{currentYear}}-{{currentYear + 1}}</footer>
    </div>
</div>


<div class="notification-container" *ngIf="showNotifications" #notificationPanel>
    <app-notification #notification (notificationLength)="getNotificationLength($event)">
    </app-notification>
</div>